// @ts-nocheck

// App
import React from 'react';
import Head from 'react-helmet';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { inline, padding, stacked } from 'app/shared/styles/_spacing';

// Components
import Button from 'app/shared/core/Button';
import Container from 'app/shared/core/Container';
import Text from 'app/shared/core/Text';
import Title from 'app/shared/modules/Title';

// Misc / Utils
import AllLogos from 'images/logos-3brands-fullcolor.svg';
import BlueBuildingsIllustration from 'images/blue-buildings-illustration.png';
import HousesIllustration from 'images/houses-illustration.svg';
import pathsManifest from 'app/shared/utils/pathsManifest';
import TealRedBuildingsIllustration from 'images/teal-red-buildings-illustration.png';
import './style.scss';

const StyledBrandContainer = styled.section`
  ${padding.top._3x};
  ${stacked._3x};
`;
const StyledHeaderContainer = styled.header`
  ${stacked._1x};
  ${padding.left._2x};
  ${padding.right._2x};
`;
const StyledAdvertiseWithZContainer = styled.section`
  ${padding.top._3x};
  ${stacked._4x};
`;
const StyledImg = styled.img`
  ${inline._2x};
`;
const StyledAdvertiseWithZButtonSection = styled.section`
  ${stacked._4x};
`;
const StyledLoginToZButtonSection = styled.section`
  ${stacked._3x};
`;
const StyledText = styled(Text)`
  ${stacked._2x};
`;
const StyledButton = styled(Button)`
  ${stacked._2x};
`;
class ListYourRentalPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <article className="ListYourRentalPage">
        <Container>
          <header>
            <Head title="List Your Rental | HotPads" />
            <Title className="ListYourRentalPage-title ListYourRentalPage-sm-center" size="lg">
              Welcome to the Zillow Group family of sites!
            </Title>
            <StyledBrandContainer className="ListYourRentalPage-sm-center">
              <img
                className="ListYourRentalPage-brand-logos"
                src={AllLogos}
                alt="Zillow, Zillow Rental Manager, and HotPads logos"
              />
            </StyledBrandContainer>
          </header>

          <section className="ListYourRentalPage-section-content">
            <StyledAdvertiseWithZContainer className="ListYourRentalPage-advertise-container">
              <StyledHeaderContainer className="ListYourRentalPage-advertise-header">
                <StyledImg
                  className="ListYourRentalPage-advertise-header-image"
                  src={BlueBuildingsIllustration}
                  alt=""
                />
                <Text htmlTag="h2" size="md" className="ListYourRentalPage-advertise-header-text">
                  Do you manage buildings with 25 or more units?
                </Text>
              </StyledHeaderContainer>
              <StyledText htmlTag="p" size="md">
                Reach renters through the largest rental network and fill your vacancies faster.
              </StyledText>
              <StyledAdvertiseWithZButtonSection className="ListYourRentalPage-button-container">
                <Button
                  className="ListYourRentalPage-button"
                  onClick={() => (window.location = pathsManifest.mfAdvertising)}
                >
                  Advertise with Zillow Group
                </Button>
              </StyledAdvertiseWithZButtonSection>
            </StyledAdvertiseWithZContainer>

            <section>
              <StyledHeaderContainer className="ListYourRentalPage-longtail-header">
                <img className="ListYourRentalPage-longtail-header-image" src={TealRedBuildingsIllustration} alt="" />
                <Text htmlTag="h2" size="md" className="ListYourRentalPage-longtail-header-text">
                  Do you own or manage properties with fewer than 25 units?
                </Text>
              </StyledHeaderContainer>
              <StyledText htmlTag="p" size="md">
                Fill your vacancies, screen renters, and collect rent — all in once place with Zillow Rental Manager.
              </StyledText>
              <StyledLoginToZButtonSection className="ListYourRentalPage-button-container">
                <StyledButton
                  className="ListYourRentalPage-button"
                  onClick={() => (window.location = pathsManifest.zrmPostAListingPage)}
                >
                  Log in to Zillow Rental Manager
                </StyledButton>
              </StyledLoginToZButtonSection>
            </section>
          </section>

          <section className="ListYourRentalPage-illustration">
            <img src={HousesIllustration} alt="" />
          </section>
        </Container>
      </article>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: state.user.loggedIn,
  };
};
export default connect(mapStateToProps)(ListYourRentalPage);
